import Alpine from 'alpinejs';

function setWidth() {
	Alpine.store('windowWidth', window.innerWidth);
}

setWidth();

const event_interval = 100;
const setWidth_throttled = Alpine.throttle(setWidth, event_interval);
const setWidth_debounced = Alpine.debounce(setWidth, event_interval);

window.addEventListener('resize', () => {
	setWidth_throttled();
	setWidth_debounced();
});